import React, { useState, useEffect } from 'react';
import '../styles/Canteen.css';
import pic1 from "../assets/nutrition .png";
import pic2 from "../assets/save-the-world .png";
import pic3 from "../assets/menu .png";
import  slider from "../assets/canteen1.webp";

const Canteen = () => {

    const [isVisible, setIsVisible] = useState(false);
            
              useEffect(() => {
                setIsVisible(true);
              }, []);
  const [currentImageSlide, setCurrentImageSlide] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);

  // Slider Images Only
  const sliderImages = [
    slider,
 
  ];

  // All Activities - Only 3 Available
  const activities = [
    {
      id: 1,
      name: 'Nutritious Meals',
      description: 'Wholesome and balanced meals prepared with fresh ingredients. Our menu is designed by nutritionists to provide essential nutrients for growing children and promote healthy eating habits.',
      icon: pic1,
    },
    {
      id: 2,
      name: 'Hygienic Environment',
      description: 'Clean and sanitized dining area maintained to highest standards. Regular health inspections and strict hygiene protocols ensure a safe eating environment for all students.',
      icon: pic2,
    },
    {
      id: 3,
      name: 'Varied Menu',
      description: 'Diverse food options catering to different tastes and dietary needs. Weekly rotating menus include continental, Indian, and healthy snack options to keep meals exciting and nutritious.',
      icon: pic3,
    }
  ];

  // Auto-play slider
  useEffect(() => {
    if (!autoPlay) return;
    
    const interval = setInterval(() => {
      setCurrentImageSlide((prev) => (prev + 1) % sliderImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [autoPlay, sliderImages.length]);

  const nextSlide = () => {
    setAutoPlay(false);
    setCurrentImageSlide((prev) => (prev + 1) % sliderImages.length);
    setTimeout(() => setAutoPlay(true), 5000);
  };

  const prevSlide = () => {
    setAutoPlay(false);
    setCurrentImageSlide((prev) => (prev - 1 + sliderImages.length) % sliderImages.length);
    setTimeout(() => setAutoPlay(true), 5000);
  };

  const goToImageSlide = (index) => {
    setAutoPlay(false);
    setCurrentImageSlide(index);
    setTimeout(() => setAutoPlay(true), 5000);
  };

  return (
    <>
      {/* Hero Banner */}
      <section className={`sgb-hero-banner ${isVisible ? 'sgb-fade-in' : ''}`}>
        <div className="sgb-hero-overlay">
          <div className="sgb-hero-text-content">
            <h1 className="sgb-hero-main-title">Canteen</h1>
          </div>
        </div>
      </section>


      {/* Main Canteen Section */}
      <section className="cnt-main-section" id="cnt-canteen-main">
        {/* About & Slider Container - Side by Side */}
        <div className="cnt-about-slider-container">
          {/* Left - About Section */}
          <div className="cnt-about-wrapper">
            <div className="cnt-description-block">
              <h2 className="cnt-section-title">About <span className="cnt-title-highlight">Our Canteen</span></h2>
              <p className="cnt-description-text">
                Our school canteen is committed to providing nutritious, delicious, and hygienic meals to all students. 
                We understand the importance of healthy eating in a child's development and academic performance. 
                With a focus on fresh ingredients, balanced nutrition, and food safety, our canteen serves as more than 
                just a dining space—it's a place where students learn healthy eating habits that last a lifetime.
              </p>
            </div>
          </div>

          {/* Right - Image Slider */}
          <div className="cnt-slider-wrapper">
            <div className="cnt-image-carousel">
              {/* Image Display */}
              <div className="cnt-image-display">
                {sliderImages.map((image, index) => (
                  <div 
                    key={index}
                    className={`cnt-image-item ${index === currentImageSlide ? 'cnt-image-active' : ''}`}
                  >
                    <img src={image} alt={`Canteen ${index + 1}`} />
                  </div>
                ))}
              </div>

            </div>
          </div>
        </div>

        {/* Canteen Activities Section */}
        <div className="cnt-content-section">
          <div className="cnt-activities-container">
            <h3 className="cnt-activities-heading">Our <span className="cnt-heading-accent">Services</span></h3>
            
            <div className="cnt-activities-grid">
              {activities.map((activity) => (
                <div 
                  key={activity.id} 
                  className="cnt-activity-card"
                >
                  <div className="cnt-card-icon">
                    <img src={activity.icon} alt={activity.name} className="cnt-item-icon"/>
                  </div>
                  <h4 className="cnt-card-title">{activity.name}</h4>
                  <p className="cnt-card-desc">{activity.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Canteen;